import consumer from "./consumer"

DealerBoost.functions.setupGoogleBusiness = function(id) {
    if(DealerBoost.channels.googleBusinessMessagesChannel !== undefined) {
        DealerBoost.channels.googleBusinessMessagesChannel.unsubscribe()
    }

    DealerBoost.channels.googleBusinessMessagesChannel = consumer.subscriptions.create({
        channel: "GoogleBusinessMessagesChannel",
        id: id
    }, {
        connected() {
        },
        disconnected() {
        },
        received(data) {
            document.getElementById(data['html_id']).innerHTML = data['html'];
            window.scrollMessageHistoryToBottom(data['chat_id'])
        }
    });
}


